import DashboardMapeamento from '@/views/mapeamento/DashboardMapeamento';
import CadastroComportamental from '@/views/mapeamento/comportamento/CadastroComportamental';
import CadastroResponsabilidade from '@/views/mapeamento/responsabilidade/CadastroResponsabilidade';
import ValidacaoResponsabilidade from '@/views/mapeamento/responsabilidade/ValidacaoResponsabilidade';

const MapeamentoRoutes = [
  {
    path: '/mapeamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Mapeamento' },
      ],
      requiresAuth: true,
    },
    name: 'DashboardMapeamento',
    component: DashboardMapeamento,
  },
  {
    path: '/mapeamento/comportamento',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Mapeamento', href: '/mapeamento' },
        { position: 3, text: 'Competências Comportamentais' },
      ],
      requiresAuth: true,
    },
    name: 'CadastroComportamental',
    component: CadastroComportamental,
  },
  {
    path: '/mapeamento/responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Mapeamento', href: '/mapeamento' },
        { position: 3, text: 'Competências Técnicas' },
      ],
      requiresAuth: true,
    },
    name: 'CadastroResponsabilidade',
    component: CadastroResponsabilidade,
  },
  {
    path: '/mapeamento/validacao-responsabilidade',
    meta: {
      breadcrumbs: [
        { position: 1, text: 'Início', href: '/inicio' },
        { position: 2, text: 'Dashboard Mapeamento', href: '/mapeamento' },
        { position: 3, text: 'Validação das Competências Técnicas' },
      ],
      requiresAuth: true,
    },
    name: 'ValidacaoResponsabilidade',
    component: ValidacaoResponsabilidade,
    props: true,
  },
];

export default MapeamentoRoutes;
